import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { initI18n } from '@/i18n/i18next'
import { router } from '@/router'
import './globals.css'

initI18n()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry:                false,
      refetchOnWindowFocus: false,
      staleTime:            30_000,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
